import {
  BASE_ENDPOINT,
  ENVIRONMENT,
  Environment,
  apiOrigin,
  dataLayer,
  getDefaultSentryOptions,
  initAmplify,
  initSentry,
  session,
  transformAppVersion,
} from '@bowtie-web/common';
import axios from 'axios';
import path from 'path';
import { version } from '../package.json';
import { APP_NAME_BASE } from './constants';
import './setupDayjs';

const {
  REACT_APP_CIRCLE_SHA1: commitHash,
  REACT_APP_SENTRY_DSN: sentryDsn,
  REACT_APP_BUILD_TIME: buildTime,
  REACT_APP_CIRCLE_PULL_REQUEST: pullRequestUrl,
} = import.meta.env;

const APP_NAME = APP_NAME_BASE;

// TODO: generalize
const pullRequest = pullRequestUrl && pullRequestUrl.match(/\/(\d+)$/)![1];
const base = `${APP_NAME}@${version}`;
const release = pullRequest ? `${base}-pr-${pullRequest}` : base;
const version_number = transformAppVersion(version);

export const initApp = () => {
  initAmplify({
    region: import.meta.env.REACT_APP_AWS_REGION,
    userPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
    identityPoolId: import.meta.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: import.meta.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    cookies: {
      domain: import.meta.env.REACT_APP_COOKIES_DOMAIN,
      path: import.meta.env.REACT_APP_COOKIES_PATH,
    },
  });

  dataLayer.push({
    app_name: APP_NAME,
    app_version: version,
    version_number: version_number,
  });

  if (sentryDsn) {
    const sentryOptions = getDefaultSentryOptions({
      apiOrigin,
      release,
      sentryDsn,
      environment: ENVIRONMENT,
    });
    initSentry(sentryOptions, APP_NAME_BASE);
  }

  if (commitHash && buildTime) {
    console.log(
      JSON.stringify(
        {
          commitHash,
          environment: ENVIRONMENT,
          release,
          buildTime: new Date(+buildTime * 1000),
        },
        null,
        2,
      ),
    );
  }

  /*
  Removes the default 'Accept: application/json, text/plain, *'
  header to allow preloading of endpoints
 */
  delete axios.defaults.headers.common.Accept;
  // FIXME: change to better method to get the locale
  axios.defaults.headers.common['Accept-Language'] = 'zh-hk';

  session.config({ uri: BASE_ENDPOINT });
};

export const startMockServiceWorker = async () => {
  if (
    ENVIRONMENT === Environment.Staging ||
    ENVIRONMENT === Environment.Production
  ) {
    return Promise.resolve();
  }

  const { handlers } = await import('./mocks/handlers');
  const { setupWorker } = await import('msw');
  const { pathname } = window.location;
  const worker = setupWorker(...handlers);
  const workerUrl = path.join(
    ENVIRONMENT === Environment.Development
      ? pathname === `/${APP_NAME}/`
        ? `/${APP_NAME}/latest/`
        : pathname
      : ENVIRONMENT === Environment.PullRequest
        ? import.meta.env.BASE_URL || ''
        : pathname.replace(/(\w*)\.html$/, ''),
    'mockServiceWorker.js',
  );
  console.log('workerUrl', workerUrl);
  return worker.start({
    serviceWorker: {
      url: workerUrl,
      options: {
        scope:
          ENVIRONMENT === Environment.PullRequest
            ? import.meta.env.BASE_URL || '/'
            : '/',
      },
    },
    onUnhandledRequest: 'bypass',
  });
};
